import * as ActionTypes from "./actionTypes";

export const saveAuthCode = authData => {
	return {
		type: ActionTypes.SAVE_AUTH_CODE,
		payload: authData,
	};
};

export const saveAuthCodeSuccess = data => {
	return {
		type: ActionTypes.SAVE_AUTH_CODE_SUCCESS,
		payload: data,
	};
};

export const saveAuthCodeFailure = errorMessage => {
	return {
		type: ActionTypes.SAVE_AUTH_CODE_FAILURE,
		payload: errorMessage,
	};
};

export const refreshAccessToken = integrationId => {
	return {
		type: ActionTypes.REFRESH_ACCESS_TOKEN,
		payload: integrationId,
	};
};

export const refreshAccessTokenSuccess = data => {
	return {
		type: ActionTypes.REFRESH_ACCESS_TOKEN_SUCCESS,
		payload: data,
	};
};

export const refreshAccessTokenFailure = errorMessage => {
	return {
		type: ActionTypes.REFRESH_ACCESS_TOKEN_FAILURE,
		payload: errorMessage,
	};
};

export const canRefresh = () => {
	return {
		type: ActionTypes.CAN_REFRESH,
	};
};

export const cannotRefresh = () => {
	return {
		type: ActionTypes.CANNOT_REFRESH,
	};
};
